import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import classes from './FilterContent.module.css';
import FilterTypeSearchBar from './FilterTypeSearchBar';

interface Props {
  setOption: (option: FilterTypeSearchBar) => void;
}

const FilterContent: FC<Props> = ({ setOption }) => {
  const [t] = useTranslation('global');
  return (
    <ul className={classes.listOptions} data-testid="filterContent">
      <li
        className={classes.option}
        onClick={() => setOption(FilterTypeSearchBar.COMPANY)}
        aria-hidden
        data-testid="filterByCompany"
      >
        <span>{t('SimeraInternal.Company')}</span>
      </li>
      <li
        className={classes.option}
        onClick={() => setOption(FilterTypeSearchBar.JOB_POSITION)}
        aria-hidden
        data-testid="filterByJobPosition"
      >
        <span>{t('SimeraInternal.JobPosition')}</span>
      </li>
      <li
        className={classes.option}
        onClick={() => setOption(FilterTypeSearchBar.JOB_ID)}
        aria-hidden
        data-testid="filterByJobId"
      >
        <span>{t('SimeraInternal.JobId')}</span>
      </li>
    </ul>
  );
};

export default FilterContent;
